<div class="my-account-page">
  <mat-tab-group [(selectedIndex)]="tabIndex" *ngIf="!isMobileView" class="my-account-tabs">
    <mat-tab label="Webinar Free Winnings">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" *ngIf="tabIndex === 0">
        <app-winning-webinar-table></app-winning-webinar-table>
      </div>
    </mat-tab>
    <mat-tab label="Purchase History">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" *ngIf="tabIndex === 1">
        <app-purchase-history-table></app-purchase-history-table>
      </div>
    </mat-tab>
    <mat-tab label="Shipping & Billing Address">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" *ngIf="tabIndex === 2"
        [ngStyle]="{'margin-top': !isMobileView ? '10px' : ''}">
        <app-user-address></app-user-address>
      </div>
    </mat-tab>
    <mat-tab label="Communication Methods">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" *ngIf="tabIndex === 3">
        <app-communication-methods></app-communication-methods>
      </div>
    </mat-tab>
    <mat-tab label="Payment Methods">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}" *ngIf="tabIndex === 4">
        <app-pyament-methods></app-pyament-methods>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="isMobileView" class="my-account-mobile">
    <mat-form-field appearance="outline" class="my-account-mobile-select">
      <mat-label>Select My Account Option</mat-label>
      <mat-select [(ngModel)]="selectedOptionToViewForMobile">
        <mat-option value="WebinarFreeWinning">Webinar Free Winnings</mat-option>
        <mat-option value="PurchaseHistory">Purchase History</mat-option>
        <mat-option value="CommunicationAddress">Shipping & Billing Address</mat-option>
        <mat-option value="CommunicationMethods">Communication Methods</mat-option>
        <mat-option value="PaymentMethods">Payment Methods</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="selectedOptionToViewForMobile === 'WebinarFreeWinning'">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <app-winning-webinar-table></app-winning-webinar-table>
      </div>
    </div>
    <div *ngIf="selectedOptionToViewForMobile === 'PurchaseHistory'">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <app-purchase-history-table></app-purchase-history-table>
      </div>
    </div>
    <div *ngIf="selectedOptionToViewForMobile === 'CommunicationAddress'">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <app-user-address></app-user-address>
      </div>
    </div>
    <div *ngIf="selectedOptionToViewForMobile === 'CommunicationMethods'">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <app-communication-methods></app-communication-methods>
      </div>
    </div>
    <div *ngIf="selectedOptionToViewForMobile === 'PaymentMethods'">
      <div [ngClass]="{'clsWrapping': !isMobileView, 'clsWrappingMobile': isMobileView}">
        <app-pyament-methods></app-pyament-methods>
      </div>
    </div>
  </div>
</div>
